window.randomQuotes = function(className, quotes) {
  var els = Array.from(document.querySelectorAll("." + className));
  els.forEach(function(el) {
    addQuoteContainer(el);
    showRandomQuote(el, quotes);
  });
  if (quotes.length > 0)
    els.forEach(function(el) {
      var button = document.createElement("button");
      button.className = "random-quote__button";
      button.innerHTML =
        require("../../../img/2016/refresh.svg") + " get another quote";
      button.addEventListener("animationend", buttonAnimationEnd);
      el.firstChild.appendChild(button);

      var transitionEnd = function(e) {
        showRandomQuote(el, quotes);
        e.currentTarget.removeEventListener("transitionend", transitionEnd);
      };

      el.firstChild.addEventListener("click", function(e) {
        replaceButton(true);

        var container = getQuoteContainer(el);
        container.addEventListener("transitionend", transitionEnd);
        container.className = "random-quote__quote--transition-out";
      });

      // Prevent double-click text selection
      el.firstChild.addEventListener("mousedown", function(e) {
        if (e.detail > 1) {
          e.preventDefault();
        }
      });

      function replaceButton(animate) {
        var newButton = button.cloneNode(true);
        newButton.className = animate
          ? "random-quote__button--animating"
          : "random-quote__button";
        newButton.addEventListener("animationend", buttonAnimationEnd);

        button.parentElement.insertBefore(newButton, button);
        button.parentElement.removeChild(button);
        button = newButton;
      }
    });
};

function buttonAnimationEnd(e) {
  e.currentTarget.className = "random-quote__button";
}

function addQuoteContainer(el) {
  el.innerHTML =
    '<span class="random-quote"><span class="random-quote__quote" aria-live="polite"></span></span>';
}

function getQuoteContainer(el) {
  return el.firstChild.firstChild;
}

function showRandomQuote(el, quotes) {
  shuffle(quotes);
  var quote = quotes.pop();
  if (!quote) return;

  if (el._quote) quotes.push(el._quote);
  el._quote = quote;
  var container = getQuoteContainer(el);
  container.innerHTML = quote.author
    ? "“" +
      quote.quote +
      '” <span style="white-space: nowrap">—' +
      quote.author +
      "</span>"
    : "“" + quote.quote + "”";
  container.className = "random-quote__quote";
}

function shuffle(array) {
  var i = 0,
    j = 0,
    temp = null;

  for (i = array.length - 1; i > 0; i -= 1) {
    j = Math.floor(Math.random() * (i + 1));
    temp = array[i];
    array[i] = array[j];
    array[j] = temp;
  }
}
